import { render } from "./fileStorage.vue?vue&type=template&id=ef612960&scoped=true"
import script from "./fileStorage.vue?vue&type=script&lang=js"
export * from "./fileStorage.vue?vue&type=script&lang=js"

import "./fileStorage.vue?vue&type=style&index=0&id=ef612960&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef612960"]])

export default __exports__